import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ProductVisual from "./ProductVisual";
import { formatINR } from "../data/catalog";
import { useCart } from "../context/CartContext";
import { EASE } from "./Reveal";

const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();
  const isSet = product.kind === "set";

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.06, ease: EASE }}
    >
      <div className="group" data-testid={`product-card-${product.slug}`}>
        <Link to={isSet ? `/shop?cat=Sets%20%26%20Gifting` : `/product/${product.slug}`} className="block">
          <ProductVisual product={product} zoomOnHover className="aspect-[4/5] w-full" />
        </Link>
        <div className="mt-4">
          <Link to={isSet ? `/shop?cat=Sets%20%26%20Gifting` : `/product/${product.slug}`}>
            <h3 className="font-serif text-lg leading-snug">{product.name}</h3>
          </Link>
          <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-ink/50">
            {isSet ? product.contents.join(" · ") : product.size}
          </p>
          <p className="mt-2 text-[13px] leading-relaxed text-ink/60">
            {isSet ? product.note : product.cardLine}
          </p>
          <div className="mt-3 flex items-center justify-between gap-3">
            <div>
              <span className="text-sm font-medium tabular-nums">{formatINR(product.price)}</span>
              <span className="ml-2 text-[10px] text-ink/40">incl. of all taxes</span>
            </div>
            <button
              onClick={() => add(product.id, 1)}
              data-testid={`add-to-cart-${product.slug}`}
              className="rounded-full border border-ink/30 px-4 py-2 text-[11px] uppercase tracking-[0.16em] transition-colors duration-300 hover:bg-ink hover:text-cream"
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;
